const filterControlsByDisplayProperties = (controls, shouldControlDisplay) =>
  controls.filter((control) => {
    if (!control.displayOptions) {
      return true;
    }
    return shouldControlDisplay(control);
  });

export default filterControlsByDisplayProperties;
